import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/customer-dashboard/wishlist/page.tsx");
